<template>
  <div class="padding-10">
    <v-card :elevation="$root.ele">
      <v-tabs v-model="tab" background-color="white">
        <v-tabs-slider></v-tabs-slider>
        <v-tab v-for="item in items" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-card>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <technicians></technicians>
      </v-tab-item>
      <v-tab-item>
        <technician-group></technician-group>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import TechnicianGroup from "../components/technicians/TechnicianGroup.vue";
import Technicians from "../components/technicians/Technicians.vue";
export default {
  components: { Technicians, TechnicianGroup },
  data() {
    return {
      tab: 0,
      items: ["Technicians", "SMS Groups"]
    };
  }
};
</script>

<style></style>
